export const mockServerResponse = (data: {}, timeout = 1000): Promise<unknown> =>
  new Promise(resolve => setTimeout(() => resolve(data), timeout)).then(
    resp => resp
  );
